import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6a318835"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = { class: "panel-network" }

import { useTokenBalance } from '@/composables/token/useTokenBalance';
import { Direction } from '@/store/modules/bridge/models/direction';
import { useCardanoBridge } from '@/store/modules/bridge/useCardanoBridge';
import { useAllWallets } from '@/store/modules/wallet/useAllWallets';
import { computed, watch } from 'vue';
import NetworkPanelHeader from './NetworkPanelHeader.vue';
import InputPanel from './InputPanel.vue';
import { Blockchain } from '@/store/modules/bridge/models/blockchain';


export default /*#__PURE__*/_defineComponent({
  __name: 'NetworkPanel',
  props: {
    direction: null,
    network: null
  },
  setup(__props: any) {

const props = __props as {
  direction: Direction;
  network: Blockchain;
}

const {
  getBlockchainByDirection,
  getTokenByDirection,
  getGasToken,
  getAmountByDirection,
  setFromAmount,
  bridgeForm,
  validateFormByNetworkAndToken,
} = useCardanoBridge();
const { isWalletInjected } = useAllWallets();



const amount = computed(() => {
  if (props.direction === 'from') {
    return bridgeForm.formFromAmount;
  }

  if (bridgeForm.fromAmount.eq(0)) {
    return '';
  }

  const toAmount = getAmountByDirection(props.direction).value;
  return toAmount?.toFixed() || '0';
});

const amountLoading = computed(
  () => props.direction === 'to' && getAmountByDirection(props.direction).value === null,
);

const blockchain = getBlockchainByDirection(props.direction);
const blockchainName = computed(() => blockchain.value.name);

const token = getTokenByDirection(props.direction);

const balance = useTokenBalance(token);
const gasTokenBalance = useTokenBalance(getGasToken());

const showBalance = isWalletInjected(blockchainName);

const selectedToken = getTokenByDirection('from').value;

const validateInput = () => {
  validateFormByNetworkAndToken();
};

watch([balance, gasTokenBalance, isWalletInjected(blockchainName)], () => {
  validateInput();
});

const onUpdateAmount = (amount: string) => {
  if (props.direction === 'from') {
    amount = amount.replace(' ', '');
    setFromAmount(amount || '0', amount);
    validateInput();
  }
};

const onSelectToken = () => {
  if (props.direction === 'from') {
    setFromAmount('0', '');
  }
  validateInput();
};
setTimeout(validateInput, 1000);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(NetworkPanelHeader, {
        direction: __props.direction,
        blockchain: props.network
      }, null, 8, ["direction", "blockchain"]),
      _createVNode(InputPanel, {
        "model-value": _unref(amount),
        loading: _unref(amountLoading),
        token: _unref(token),
        balance: _unref(balance),
        adaBalance: _unref(gasTokenBalance),
        "not-max-button": __props.direction === 'to',
        "show-balance": _unref(showBalance),
        readonly: __props.direction === 'to',
        direction: __props.direction,
        selectedTokenDecimals: _unref(selectedToken).decimals,
        "onUpdate:modelValue": onUpdateAmount,
        onTokenSelected: onSelectToken
      }, null, 8, ["model-value", "loading", "token", "balance", "adaBalance", "not-max-button", "show-balance", "readonly", "direction", "selectedTokenDecimals"])
    ])
  ]))
}
}

})